module.exports = __webpack_public_path__ + "static/media/rock_paper_scissors2.3767aeef.png";